var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from 'classnames';
import React from 'react';
import { MedicationExpiry, MedicationStatus } from '../Contracts/MedicationModels';
import { heading, medicationAboutToExpireText, medicationExpired } from '../Styles/Colours';
import styles from './MedicationTextHighlighter.module.css';
import { isNumber } from 'lodash';
export var MedicationTextHighlighter = React.forwardRef(function (props, ref) {
    var _a;
    var selected = props.selected, status = props.status, expiryStatus = props.expiryStatus, width = props.width, otherProps = __rest(props, ["selected", "status", "expiryStatus", "width"]);
    var stopped = props.status === MedicationStatus.Stopped;
    var expired = props.expiryStatus === MedicationExpiry.Expired;
    var aboutToExpire = props.expiryStatus === MedicationExpiry.AboutToExpire;
    var textColour = function () {
        if (expired && selected && !stopped)
            return medicationExpired;
        if (aboutToExpire && selected && !stopped)
            return medicationAboutToExpireText;
        return heading;
    };
    var textClasses = classNames(styles.rowText, (_a = {},
        _a[styles.width] = !!width,
        _a));
    var myWidth = width === undefined ? 'none' : isNumber(width) ? width + "px" : width;
    var textStyles = { color: textColour(), width: myWidth };
    return (React.createElement("span", __assign({}, otherProps, { ref: ref, className: textClasses, style: textStyles }), props.children));
});
